var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.44 20.45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.15 18.74-4-4A9.05 9.05 0 0 0 9.06 0a9.06 9.06 0 0 0 0 18.12 9 9 0 0 0 5.65-2l4 4a1 1 0 0 0 1.41-1.41ZM9.06 16.12A7.06 7.06 0 0 1 9.06 2a7.06 7.06 0 1 1 0 14.12Z"
  })));
};
export default SvgMagnifier;